module.exports = __webpack_public_path__ + "static/media/curved-bg-payment.bce50cd0.svg";